import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface DashboardState {
  yesterday: {
    date: string;
    revenue_minor: number;
    vat_minor: number;
    eco_tax_minor: number;
    rows_delivered: number;
  };
  thirty_day_health: { date: string; success: boolean }[];
}

function buildHealth(): DashboardState["thirty_day_health"] {
  return Array.from({ length: 30 }, (_, i) => {
    const d = new Date(2026, 3, 26 + i);
    const iso = d.toISOString().slice(0, 10);
    return { date: iso, success: !(i === 5 || i === 18) };
  });
}

const initialState: DashboardState = {
  yesterday: {
    date: "2026-05-24",
    revenue_minor: 482050,
    vat_minor: 33744,
    eco_tax_minor: 7650,
    rows_delivered: 142,
  },
  thirty_day_health: buildHealth(),
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setHealthDay(
      state,
      action: PayloadAction<{ date: string; success: boolean }>,
    ) {
      const idx = state.thirty_day_health.findIndex(
        (d) => d.date === action.payload.date,
      );
      if (idx >= 0) state.thirty_day_health[idx] = action.payload;
    },
  },
});

export const { setHealthDay } = slice.actions;
export default slice.reducer;
